import {
	Stack,
} from '@mui/material'
import {
	forwardRef,
} from 'react'

import type {
	StackProps,
} from '../stack/stack.types'

const VStack = forwardRef<HTMLDivElement, StackProps>((
	props,
	ref,
) => {
	const {
		children,
		spacing = 0,
		...other
	} = props

	return (
		<Stack
			ref={ref}
			spacing={spacing}
			direction='column'
			{...other}
		>
			{children}
		</Stack>
	)
})

export default VStack
